/**
 * Client-side env vars (BUN_PUBLIC_*). Bun replaces these at build/serve time.
 * Do NOT add server-only vars (e.g. PORT) here — client code would reference
 * process and crash in the browser.
 */
export const PUBLIC_WEBSITE = process.env.BUN_PUBLIC_WEBSITE || ''
export const MARKDOWN_PLUGIN_URL = process.env.BUN_PUBLIC_MARKDOWN_PLUGIN_URL || ''
export const REST_API = process.env.BUN_PUBLIC_REST_API || ''
export const FEED_CDN = process.env.BUN_PUBLIC_FEED_CDN || ''
export const PUB_CDN = process.env.BUN_PUBLIC_PUB_CDN || ''